export default __webpack_public_path__ + "static/LinkedIn-cd7eb6fcf9f6360de4bde36d465c26c1.jpg";